import baseStyles from "./toolbox-components.module.css";
import styles from "./toolbox-component-font-picker.module.css";

import { useState } from "react";
import { ToolboxComponentDropdown as Dropdown } from "./toolbox-component-dropdown";
import classNames from "classnames";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { ToolboxComponentSection as Section } from "./toolbox-component-section";

interface ToolboxComponentFontPickerProps {
  fontNames: string[];
  selectedFont?: string;
  onSelectFont: (fontName: string) => void;
  className?: string;
}

export const ToolboxComponentFontPicker = (
  props: ToolboxComponentFontPickerProps
) => {
  const { project } = usePosterProject();
  const [isVisible, setIsVisible] = useState(false);

  const usedFonts = () => {
    const fonts = new Set<string>();
    if (project) {
      fonts.add(project.staticLabelStyle.font);
      fonts.add(project.mapLabelStyle.font);
    }
    return Array.from(fonts);
  };

  const Label = () => {
    return (
      <div className={classNames(styles.fontPickerLabel, props.className)}>
        <span style={{ fontFamily: props.selectedFont ?? "sans-serif" }}>
          {props.selectedFont ?? "Font"}
        </span>
        <img
          className={styles.expandChevron}
          src={
            !isVisible
              ? "/pallete-components/CHEVRON-DOWN-ICON.svg"
              : "/pallete-components/CHEVRON-UP-ICON.svg"
          }
          alt="Collapse tool Toolbox"
        />
      </div>
    );
  };

  return (
    <Dropdown
      isVisible={isVisible}
      onToggleVisibility={() => setIsVisible((prev) => !prev)}
      label={<Label />}
    >
      <div className={styles.fontPickerContainer}>
        <div className={styles.sectionTitle}>Recent</div>

        {usedFonts().map((fontName) => (
          <button
            key={fontName}
            className={classNames(styles.fontName, {
              [styles.selectedFontName]: fontName === props.selectedFont,
            })}
            style={{ fontFamily: fontName }}
            onClick={() => {
              props.onSelectFont(fontName);
              setIsVisible(false);
            }}
          >
            {fontName}
          </button>
        ))}
        <div className={styles.sectionTitle}>All fonts</div>
        {props.fontNames.map((fontName) => (
          <button
            key={fontName}
            className={classNames(styles.fontName, {
              [styles.selectedFontName]: fontName === props.selectedFont,
            })}
            style={{ fontFamily: fontName }}
            onClick={() => {
              props.onSelectFont(fontName);
              setIsVisible(false);
            }}
          >
            {fontName}
          </button>
        ))}
      </div>
    </Dropdown>
  );
};
